import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen w-screen bg-[#0A0A0A] flex items-center justify-center text-zinc-500 text-sm">
        Yükleniyor…
      </div>
    );
  }
  if (!token) return <Navigate to="/login" replace />;
  return children;
};
